module.exports = __webpack_public_path__ + "static/media/memberships-shot-3.c4937870.png";